import { render, staticRenderFns } from "./CedexTags.vue?vue&type=template&id=00182806&scoped=true&"
import script from "./CedexTags.vue?vue&type=script&lang=js&"
export * from "./CedexTags.vue?vue&type=script&lang=js&"
import style0 from "./CedexTags.vue?vue&type=style&index=0&id=00182806&scoped=true&lang=css&"
import style1 from "./CedexTags.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00182806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VPagination,VSelect,VTextField})
